var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"alert-handler"},[_vm._l((_vm.activeAlerts.slice(0, 3)),function(alert){return [_c('Alert',{key:`alert-${alert.id}`,attrs:{"type":alert.type,"title":alert.title,"text":alert.text},on:{"close":function($event){return _vm.closeAlert(alert.id)}}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }